export default "__VITE_ASSET__BevBbGVL__"